import { Component, EventEmitter, OnInit, Output, Input } from "@angular/core";
import { User } from "../../../model/users";
import { BehaviorSubject } from "rxjs";
import { UsersService } from "../../../services/users.service";
import { AuthService } from "../../../auth.service";
import { Router } from "@angular/router";
import { Navigation } from "../../../model/navigation";
import { SingleChoice } from "../../../model/singlechoice";
import { Messages } from "../../../model/messages";

@Component({
  selector: "users",
  templateUrl: "./users.component.html",
  styleUrls: ["./users.component.css"],
})
export class UsersComponent implements OnInit {
  userCount: number = 0;
  users: BehaviorSubject<User[]> = new BehaviorSubject<User[]>([]);
  filteredUsers: BehaviorSubject<User[]> = new BehaviorSubject<User[]>([]);
  searchTerm: BehaviorSubject<string> = new BehaviorSubject<string>("");
  selectedUser: User | null = null;
  messages: BehaviorSubject<Messages>;
  title: BehaviorSubject<string> = new BehaviorSubject<string>("");
  @Output() userSelected = new EventEmitter<number>();
  @Output() createNew = new EventEmitter<void>();
  @Input() choiceEvent: SingleChoice = SingleChoice.EMPTY;
  @Input() isMobile: boolean = false;

  constructor(
    private userService: UsersService,
    private auth: AuthService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.title.next("users.title");
    const token = this.auth.token;

    this.userService.users(token).subscribe({
      next: (messages) => {
        if (messages.hasAnyMessages) {
          this.messages.next(messages);
        }
      },
      complete: () => {},
    });

    this.userService.usersObservable.subscribe((data) => {
      const sortedUsers = data.sort((a: User, b: User) =>
        a.displayname.localeCompare(b.displayname)
      );
      this.users.next(sortedUsers);
      this.filteredUsers.next(sortedUsers);
      this.userCount = sortedUsers.length;
    });
  }

  searchUsers(): void {
    const query = this.searchTerm.getValue().toLowerCase();

    const filtered = query
      ? this.users.value.filter((user) =>
          user.displayname.toLowerCase().includes(query)
        )
      : this.users.value;

    this.filteredUsers.next(filtered);
  }

  select(user: User) {
    this.selectedUser = user;
    this.userService.select(user);
    if (this.choiceEvent && this.choiceEvent.topic == "users") {
      if (user && user.id) {
        this.userService.makeBackgroundColor(user.id).subscribe((color) => {
          const background = color;
          this.userService.makeColor(user.id!!).subscribe((c) => {
            const color = c;
            this.choiceEvent.choose(
              user.id!!,
              user.displayname,
              background,
              color,
              1
            );
          });
        });
      }
    } else {
      this.userService.select(user);

      if (user && user.id) {
        this.router.navigate([`users/${user.id}`]).then(() => {
          this.userSelected.emit(user.id!!);
        });
      }
    }
  }

  createNewUser() {
    this.createNew.emit();
    const newUser = new User(Navigation.NEW, "", "", "", false, false);
    this.userService.select(newUser);
    this.router.navigate([`users/` + Navigation.NEW]).then(() => {
      this.userSelected.emit(Navigation.NEW);
    });
  }
  clearFilter() {
    this.searchTerm.next("");
    this.filteredUsers.next(this.users.value);
  }
}
